import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import WidgetAction, { WidgetTypes } from 'Redux/WidgetRedux'
import SettingsAction, { SettingsSelectors } from 'Redux/SettingsRedux'

export function* getAll(api, action) {
  const resp = yield call(api.getWidgets, action.params)
  if (resp.ok) {
    yield put(WidgetAction.widgetsListSuccess(resp.data))
  } else {
    yield put(WidgetAction.widgetsListFailure('something went wrong'))
  }
}

export function* onCreate(api, action) {
  const resp = yield call(api.createWidget, action.params)
  if (resp.ok) {
    yield put(WidgetAction.widgetsCreateSuccess(resp.data))
    action.callback()
  } else {
    yield put(WidgetAction.widgetsCreateFailure('something went wrong'))
    action.callback()
  }
}

export function* deleteWidget(api, action) {
  const resp = yield call(api.deleteWidget, action.id)
  if (resp.ok) {
    yield put(WidgetAction.widgetsDeleteSuccess())
    action.callback()
  } else {
    yield put(WidgetAction.widgetsDeleteFailure())
    action.callback()
  }
}

export function* onUpdate(api, action) {
  const resp = yield call(api.updateWidget, action.params.id, action.params)
  if (resp.ok) {
    yield put(WidgetAction.widgetsUpdateSuccess(resp.data))
    action.callback('success')
  } else {
    yield put(WidgetAction.widgetsUpdateFailure('something went wrong'))
    action.callback('failure')
  }
}

export function* detailsRequest(api, action) {
  const resp = yield call(api.getWidgetDetails, action.id)
  if (resp.ok) {
    yield put(WidgetAction.widgetsDetailSuccess(resp.data))
  } else {
    yield put(WidgetAction.widgetsDetailFailure('something went wrong'))
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(WidgetTypes.WIDGETS_LIST_REQUEST, getAll, api),
    takeLatest(WidgetTypes.WIDGETS_DETAIL_REQUEST, detailsRequest, api),
    takeLatest(WidgetTypes.WIDGETS_CREATE_REQUEST, onCreate, api),
    takeLatest(WidgetTypes.WIDGETS_UPDATE_REQUEST, onUpdate, api),
    takeLatest(WidgetTypes.WIDGETS_DELETE_REQUEST, deleteWidget, api),
  ])
}
